module.exports = __webpack_public_path__ + "img/alexamar.6227a702.png";